import { render, staticRenderFns } from "./lender-details.vue?vue&type=template&id=90593268&scoped=true"
import script from "./lender-details.vue?vue&type=script&lang=js"
export * from "./lender-details.vue?vue&type=script&lang=js"
import style0 from "./lender-details.vue?vue&type=style&index=0&id=90593268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90593268",
  null
  
)

export default component.exports